import { supabase } from '../services/supabase/client';

/**
 * 跨裝置驗證：桌機無 session 時，用 public.users.is_verified（由 auth 觸發器同步）判斷。
 * 若 DB 曾用手動 SQL 建立為 i_email，會再試一次。
 */
export async function isEmailVerifiedViaPublicRpc(email: string): Promise<boolean> {
  const trimmed = email.trim();
  if (!trimmed) return false;

  const { data, error } = await supabase.rpc('is_email_verified_public', {
    p_email: trimmed,
  });
  if (!error && data === true) return true;

  const { data: legacy, error: legacyErr } = await supabase.rpc(
    'is_email_verified_public',
    { i_email: trimmed } as { i_email: string }
  );
  if (!legacyErr && legacy === true) return true;

  return false;
}
